import React from "react";
import { Icon } from "@iconify/react";

const ServiceCard = ({ title, description, icon }) => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-lg transition">
      <Icon icon={icon} className="text-[32px] text-[#002F6C] m-2" />
      <h3 className="text-[20px] font-semibold text-gray-800">{title}</h3>
      <p className="text-gray-600 mt-2">{description}</p>
    </div>
  );
};

export default ServiceCard;
